(function () {
  'use strict';

  function initCollection(root) {
    if (!root || root.dataset.tmpgCollectionAjaxInitialized === 'true') return;

    var filterForm = root.querySelector('.tcx-rail__form');
    var gridZone = root.querySelector('.tcx-grid-zone');
    var toolbarCount = root.querySelector('.tcx-toolbar__count');
    if (!filterForm || !gridZone || !toolbarCount) return;

    root.dataset.tmpgCollectionAjaxInitialized = 'true';

    var collectionPath = window.location.pathname;
    var activeController = null;
    var requestSequence = 0;
    var mobileQuery = window.matchMedia('(max-width: 1023px)');

    function textOf(element) {
      return element ? element.textContent.trim() : '';
    }

    function getFocusContext(link) {
      if (link.classList.contains('tcx-opt')) {
        var facet = link.closest('.tcx-facet');
        return {
          type: 'option',
          facet: textOf(facet && facet.querySelector('.tcx-facet__label')),
          label: textOf(link.querySelector('.tcx-opt__name'))
        };
      }
      if (link.classList.contains('tcx-art-tag')) {
        return { type: 'tag', label: textOf(link.querySelector('.tcx-art-tag__name')) };
      }
      if (link.classList.contains('tcx-chip')) {
        return { type: 'chip', label: textOf(link).replace(/\s*×\s*$/, '') };
      }
      return { type: 'clear', label: '' };
    }

    function captureState() {
      var rail = root.querySelector('.tcx-rail');
      return {
        railOpen: rail ? rail.open : false,
        filterScrollTop: filterForm.scrollTop,
        scrollX: window.scrollX,
        scrollY: window.scrollY
      };
    }

    function replaceInner(source, target) {
      while (target.firstChild) target.removeChild(target.firstChild);
      Array.prototype.forEach.call(source.childNodes, function (node) {
        target.appendChild(document.importNode(node, true));
      });
    }

    function syncOptionalElement(nextRoot, selector, insertAfterSelector) {
      var current = root.querySelector(selector);
      var next = nextRoot.querySelector(selector);
      if (current && next) {
        current.replaceWith(document.importNode(next, true));
      } else if (current && !next) {
        current.remove();
      } else if (!current && next) {
        var anchor = root.querySelector(insertAfterSelector);
        if (anchor) anchor.insertAdjacentElement('afterend', document.importNode(next, true));
      }
    }

    function syncGrid(nextRoot) {
      var currentGrid = root.querySelector('#tcx-grid');
      var nextGrid = nextRoot.querySelector('#tcx-grid');
      var nextGridZone = nextRoot.querySelector('.tcx-grid-zone');
      if (!nextGridZone) throw new Error('Collection grid response is incomplete');

      if (currentGrid && nextGrid) {
        currentGrid.className = nextGrid.className;
        replaceInner(nextGrid, currentGrid);
      } else {
        replaceInner(nextGridZone, gridZone);
      }
    }

    function attachDynamicLoadMore(button) {
      if (!button || button.dataset.tmpgDynamicLoadMore === 'true') return;
      button.dataset.tmpgDynamicLoadMore = 'true';
      var busy = false;
      var label = button.textContent;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (busy) return;
        busy = true;
        button.textContent = 'Retrieving works …';

        fetch(button.href)
          .then(function (response) {
            if (!response.ok) throw new Error('http');
            return response.text();
          })
          .then(function (html) {
            var documentNext = new DOMParser().parseFromString(html, 'text/html');
            var grid = root.querySelector('#tcx-grid');
            var gridNext = documentNext.querySelector('#tcx-grid');
            var buttonNext = documentNext.querySelector('#tcx-more-btn');
            if (!grid || !gridNext) throw new Error('parse');
            while (gridNext.firstChild) grid.appendChild(gridNext.firstChild);
            var counter = root.querySelector('#tcx-more-count');
            var total = parseInt(button.getAttribute('data-total') || '0', 10);
            if (counter) counter.textContent = grid.querySelectorAll('.tcx-plate').length + ' of ' + total + ' works';
            if (buttonNext) {
              button.href = buttonNext.href;
              button.textContent = label;
            } else {
              button.style.display = 'none';
            }
            busy = false;
          })
          .catch(function () { window.location.assign(button.href); });
      });
    }

    function syncPagination(nextRoot) {
      var currentMore = root.querySelector('#tcx-more');
      var nextMore = nextRoot.querySelector('#tcx-more');

      if (!nextMore) {
        if (currentMore) currentMore.remove();
        return;
      }

      if (!currentMore) {
        currentMore = document.importNode(nextMore, true);
        root.appendChild(currentMore);
        attachDynamicLoadMore(currentMore.querySelector('#tcx-more-btn'));
        return;
      }

      var currentButton = currentMore.querySelector('#tcx-more-btn');
      var nextButton = nextMore.querySelector('#tcx-more-btn');
      var currentCounter = currentMore.querySelector('#tcx-more-count');
      var nextCounter = nextMore.querySelector('#tcx-more-count');

      if (nextButton) {
        if (!currentButton) {
          currentButton = document.importNode(nextButton, true);
          currentMore.insertBefore(currentButton, currentMore.firstChild);
          attachDynamicLoadMore(currentButton);
        } else {
          currentButton.href = nextButton.href;
          currentButton.textContent = nextButton.textContent;
          currentButton.setAttribute('data-total', nextButton.getAttribute('data-total') || '0');
          currentButton.style.display = '';
        }
      } else if (currentButton) {
        currentButton.remove();
      }

      if (currentCounter && nextCounter) {
        currentCounter.textContent = nextCounter.textContent;
      } else if (!currentCounter && nextCounter) {
        currentMore.appendChild(document.importNode(nextCounter, true));
      }
    }

    function syncResponse(nextRoot) {
      var nextFilterForm = nextRoot.querySelector('.tcx-rail__form');
      var nextToolbarCount = nextRoot.querySelector('.tcx-toolbar__count');
      if (!nextFilterForm || !nextToolbarCount) throw new Error('Collection filter response is incomplete');

      replaceInner(nextFilterForm, filterForm);
      replaceInner(nextToolbarCount, toolbarCount);

      var summaryCount = root.querySelector('.tcx-rail__summary-count');
      var nextSummaryCount = nextRoot.querySelector('.tcx-rail__summary-count');
      if (summaryCount && nextSummaryCount) summaryCount.textContent = nextSummaryCount.textContent;

      var artTags = root.querySelector('.tcx-art-tags');
      var nextArtTags = nextRoot.querySelector('.tcx-art-tags');
      if (artTags && nextArtTags) replaceInner(nextArtTags, artTags);

      syncOptionalElement(nextRoot, '.tcx-chips', '.tcx-toolbar');
      syncGrid(nextRoot);
      syncPagination(nextRoot);
    }

    function findFocusTarget(context) {
      var target = null;

      if (context && context.type === 'option') {
        root.querySelectorAll('.tcx-opt').forEach(function (option) {
          if (target) return;
          var facet = option.closest('.tcx-facet');
          if (textOf(facet && facet.querySelector('.tcx-facet__label')) === context.facet &&
              textOf(option.querySelector('.tcx-opt__name')) === context.label) target = option;
        });
      } else if (context && context.type === 'tag') {
        root.querySelectorAll('.tcx-art-tag').forEach(function (tag) {
          if (!target && textOf(tag.querySelector('.tcx-art-tag__name')) === context.label) target = tag;
        });
      } else if (context && context.type === 'chip') {
        root.querySelectorAll('.tcx-opt').forEach(function (option) {
          if (!target && textOf(option.querySelector('.tcx-opt__name')) === context.label) target = option;
        });
      }

      return target || root.querySelector('.tcx-rail__summary');
    }

    function syncRailAria() {
      var rail = root.querySelector('.tcx-rail');
      var summary = rail && rail.querySelector('.tcx-rail__summary');
      if (rail && summary) summary.setAttribute('aria-expanded', rail.open ? 'true' : 'false');
    }

    function restoreState(state, focusContext, closeMobile) {
      var rail = root.querySelector('.tcx-rail');
      var summary = rail && rail.querySelector('.tcx-rail__summary');

      if (rail) rail.open = state.railOpen;
      filterForm.scrollTop = state.filterScrollTop;

      if (closeMobile && mobileQuery.matches && rail) {
        rail.removeAttribute('open');
        syncRailAria();
        if (summary) summary.focus({ preventScroll: true });
      } else {
        syncRailAria();
        var focusTarget = findFocusTarget(focusContext);
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }

      window.scrollTo(state.scrollX, state.scrollY);
      window.requestAnimationFrame(function () {
        window.scrollTo(state.scrollX, state.scrollY);
      });
    }

    async function updateCollection(href, options) {
      var sequence = ++requestSequence;
      if (activeController) activeController.abort();
      activeController = new AbortController();
      var controller = activeController;
      var state = captureState();

      root.setAttribute('aria-busy', 'true');

      try {
        var response = await fetch(href, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Collection filter request failed');

        var html = await response.text();
        if (sequence !== requestSequence) return;

        var documentNext = new DOMParser().parseFromString(html, 'text/html');
        var nextRoot = documentNext.querySelector('[data-tmpg-collection-ajax]');
        if (!nextRoot) throw new Error('Collection response is incomplete');

        syncResponse(nextRoot);
        if (options.pushState) history.pushState({ tmpgCollectionFilter: true }, '', href);
        restoreState(state, options.focusContext || null, options.closeMobile === true);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(href);
      } finally {
        if (sequence === requestSequence) {
          root.removeAttribute('aria-busy');
          if (activeController === controller) activeController = null;
        }
      }
    }

    root.addEventListener('click', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;
      var link = event.target.closest('.tcx-opt, .tcx-art-tag, .tcx-chip, .tcx-chips__clear, .tcx-empty__reset');
      if (!link || !root.contains(link)) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var href = link.getAttribute('href');
      if (!href) return;

      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || url.pathname !== collectionPath) return;

      event.preventDefault();
      event.stopPropagation();
      updateCollection(link.href, {
        pushState: true,
        focusContext: getFocusContext(link),
        closeMobile: true
      });
    });

    var rail = root.querySelector('.tcx-rail');
    if (rail) rail.addEventListener('toggle', syncRailAria);
    syncRailAria();

    window.addEventListener('popstate', function () {
      var url = new URL(window.location.href);
      if (url.pathname !== collectionPath) return;
      updateCollection(window.location.href, {
        pushState: false,
        focusContext: null,
        closeMobile: false
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-tmpg-collection-ajax]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
